const internationalRouter = {
  path: '/reimburse',
  component: () => import('@/layout'),
  children: [
    {
      path: '',
      name: 'Reimburse',
      component: () => import(/* webpackChunkName: "international" */ '@/pages/reimburse')
    },
    {
      path: '/reimburse/detail',
      name: 'ReimburseDetail',
      component: () =>
        import(/* webpackChunkName: "international" */ '@/pages/reimburse/page/detail')
    },
    {
      path: '/reimburse/intervention',
      name: 'ReimburseIntervention',
      component: () =>
        import(/* webpackChunkName: "international" */ '@/pages/reimburse/page/intervention')
    }
  ]
}

export default internationalRouter
